var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader full-page"},[_c('div',{staticClass:"text-center text-white"},[(_vm.title)?_c('h3',{staticClass:"mb-4 text-white",domProps:{"textContent":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),_c('loading-indicator',{attrs:{"size":"5x","icon-classes":"text-white"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }